import React, {useEffect} from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./modal-overlay.scss";
import Overlay from "../overlay/overlay";

const ModalOverlay = ({children, className}) => {
    useEffect(() => {
        document.body.classList.add("modal-open");
        return () => {
            document.body.classList.remove("modal-open");
        };
    }, []);

    return (
        <Overlay>
            <div className={classnames("modal-content", className)}>{children}</div>
        </Overlay>
    );
};

ModalOverlay.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};
ModalOverlay.defaultProps = {
    className: undefined,
};

export default ModalOverlay;
